/*
 * NodeIcons — Clean 20×20 SVG icon components for each workflow node type.
 * Uses currentColor for stroke so icons inherit category color from CSS.
 */

import React from 'react';

const svgProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const UploadIcon = () => (
  <svg {...svgProps}>
    <rect x="3" y="3" width="14" height="14" rx="2" />
    <polyline points="10,12 10,6" />
    <polyline points="7,8 10,5 13,8" />
  </svg>
);

export const OcrIcon = () => (
  <svg {...svgProps}>
    <rect x="3" y="2" width="14" height="16" rx="2" />
    <line x1="6" y1="6" x2="14" y2="6" />
    <line x1="6" y1="9" x2="14" y2="9" />
    <line x1="6" y1="12" x2="10" y2="12" />
    <path d="M12 14l2-2 2 2" strokeWidth="1.25" />
  </svg>
);

export const ExtractIcon = () => (
  <svg {...svgProps}>
    <rect x="2" y="2" width="11" height="16" rx="2" />
    <line x1="5" y1="6" x2="10" y2="6" />
    <line x1="5" y1="9" x2="10" y2="9" />
    <line x1="5" y1="12" x2="8" y2="12" />
    <polyline points="14,8 17,10 14,12" />
  </svg>
);

export const ClassifyIcon = () => (
  <svg {...svgProps}>
    <path d="M3 5h3l1-2h6l1 2h3v12H3z" />
    <line x1="7" y1="10" x2="13" y2="10" />
    <line x1="7" y1="13" x2="11" y2="13" />
  </svg>
);

export const DecisionIcon = () => (
  <svg {...svgProps}>
    <path d="M10 2l7 8-7 8-7-8z" />
  </svg>
);

export const ReviewIcon = () => (
  <svg {...svgProps}>
    <circle cx="10" cy="7" r="3" />
    <path d="M4 17c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <polyline points="8,12 9.5,14 13,10" strokeWidth="1.75" />
  </svg>
);

export const SetFieldIcon = () => (
  <svg {...svgProps}>
    <rect x="3" y="4" width="14" height="12" rx="2" />
    <line x1="6" y1="8" x2="14" y2="8" />
    <path d="M11 11l1.5-1.5L14 11" strokeWidth="1.25" />
    <line x1="6" y1="12" x2="9" y2="12" />
  </svg>
);

export const MapFieldsIcon = () => (
  <svg {...svgProps}>
    <rect x="2" y="3" width="6" height="14" rx="1.5" />
    <rect x="12" y="3" width="6" height="14" rx="1.5" />
    <line x1="5" y1="7" x2="5" y2="7.01" strokeWidth="2" />
    <line x1="5" y1="10" x2="5" y2="10.01" strokeWidth="2" />
    <line x1="5" y1="13" x2="5" y2="13.01" strokeWidth="2" />
    <line x1="15" y1="7" x2="15" y2="7.01" strokeWidth="2" />
    <line x1="15" y1="10" x2="15" y2="10.01" strokeWidth="2" />
    <line x1="15" y1="13" x2="15" y2="13.01" strokeWidth="2" />
    <path d="M8 7l4 3" />
    <path d="M8 10l4 0" />
    <path d="M8 13l4-3" />
  </svg>
);

export const PublishIcon = () => (
  <svg {...svgProps}>
    <rect x="3" y="3" width="14" height="14" rx="2" />
    <polyline points="10,13 10,7" />
    <polyline points="7,9 10,6 13,9" />
    <line x1="6" y1="15" x2="14" y2="15" strokeWidth="1.25" />
  </svg>
);

export const ArchiveIcon = () => (
  <svg {...svgProps}>
    <rect x="2" y="3" width="16" height="4" rx="1" />
    <path d="M3 7v8a2 2 0 002 2h10a2 2 0 002-2V7" />
    <line x1="8" y1="11" x2="12" y2="11" />
  </svg>
);

export const CloudSourceIcon = () => (
  <svg {...svgProps}>
    <path d="M5.5 15a3.5 3.5 0 0 1 .3-6.99 5 5 0 0 1 9.6 1.1A3 3 0 0 1 15 15z" />
  </svg>
);

export const DefaultNodeIcon = () => (
  <svg {...svgProps}>
    <circle cx="10" cy="10" r="7" />
    <polyline points="10,6 10,10 13,12" />
  </svg>
);

const ICON_MAP = {
  trigger_upload: UploadIcon,
  trigger_cloud_source: CloudSourceIcon,
  action_await_ocr: OcrIcon,
  action_ocr: OcrIcon, // DEPRECATED alias — renamed to action_await_ocr
  action_extract: ExtractIcon,
  action_classify: ClassifyIcon,
  decision: DecisionIcon,
  action_human_review: ReviewIcon,
  action_set_field: SetFieldIcon,
  action_field_mapping: MapFieldsIcon,
  output_publish: PublishIcon,
  output_archive: ArchiveIcon,
};

export function getNodeIcon(type) {
  return ICON_MAP[type] || DefaultNodeIcon;
}
